import {useQuery} from "react-query"
import {AuthApi} from "api/auth.api"
import {AccessTokenInfo} from "dto/auth/Authentication"

export const useFindUserInfo = (tokenInfo: AccessTokenInfo) => {
    return useQuery("findUserInfo", () => {
        return AuthApi.findUserInfo(tokenInfo.access_token)
    }, {
        enabled: !!tokenInfo.access_token
    })
}